import styled from 'styled-components';

// ============================================================================
// SWAP LEG LAYOUT — shared by IR Swap, Total Return Swap, Currency Swap
// ============================================================================

export const SwapLegsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 0;
  margin: 1.25rem 0;
  align-items: stretch;

  input,
  select {
    width: 100%;
    box-sizing: border-box;
  }

  @media (max-width: 1020px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const SwapLegPanel = styled.div<{ variant: 'receive' | 'pay' }>`
  min-width: 0;
  background: ${props =>
    props.variant === 'receive'
      ? 'radial-gradient(circle at 100% 0%, rgba(16, 185, 129, 0.12) 0%, rgba(15, 23, 42, 0) 42%), rgba(15, 23, 42, 0.72)'
      : 'radial-gradient(circle at 0% 0%, rgba(99, 102, 241, 0.13) 0%, rgba(15, 23, 42, 0) 42%), rgba(15, 23, 42, 0.72)'};
  border: 1px solid
    ${props =>
      props.variant === 'receive'
        ? 'rgba(16, 185, 129, 0.34)'
        : 'rgba(129, 140, 248, 0.34)'};
  border-radius: 14px;
  padding: 1.25rem 1.5rem;
  box-shadow: 0 14px 38px rgba(0, 0, 0, 0.18);
`;

export const SwapLegHeader = styled.div<{ variant: 'receive' | 'pay' }>`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 1.25rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid
    ${props =>
      props.variant === 'receive'
        ? 'rgba(16, 185, 129, 0.2)'
        : 'rgba(99, 102, 241, 0.2)'};
`;

export const SwapLegTitle = styled.h3<{ variant: 'receive' | 'pay' }>`
  font-size: 0.9375rem;
  font-weight: 850;
  color: ${props =>
    props.variant === 'receive' ? '#34d399' : '#a5b4fc'};
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  overflow-wrap: anywhere;
`;

export const SwapLegIcon = styled.span<{ variant: 'receive' | 'pay' }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 900;
  color: ${props => props.variant === 'receive' ? '#6ee7b7' : '#c4b5fd'};
  background: ${props =>
    props.variant === 'receive'
      ? 'rgba(16, 185, 129, 0.15)'
      : 'rgba(99, 102, 241, 0.15)'};
  border: 1px solid ${props =>
    props.variant === 'receive'
      ? 'rgba(16, 185, 129, 0.28)'
      : 'rgba(129, 140, 248, 0.28)'};
`;

export const SwapArrowDivider = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 0.75rem;
  gap: 6px;

  @media (max-width: 1020px) {
    padding: 0;
  }
`;

export const SwapArrow = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(2, 6, 23, 0.78);
  border: 1px solid rgba(125, 211, 252, 0.34);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7dd3fc;
  font-size: 18px;
  font-weight: 700;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.22);

  @media (max-width: 1020px) {
    transform: rotate(90deg);
    margin: -4px auto;
  }
`;

export const LegFormRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 680px) {
    grid-template-columns: 1fr;
  }
`;

export const LegFormRowSingle = styled.div`
  min-width: 0;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SwapDirectionToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(71, 85, 105, 0.62);
  background: rgba(2, 6, 23, 0.42);

  @media (max-width: 760px) {
    flex-wrap: wrap;
  }
`;

export const DirectionOption = styled.button<{ active?: boolean; variant: 'receive' | 'pay' }>`
  padding: 0.5rem 1rem;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  min-height: 36px;
  white-space: nowrap;
  background: ${props => {
    if (!props.active) return 'rgba(15, 23, 42, 0.7)';
    return props.variant === 'receive'
      ? 'rgba(16, 185, 129, 0.2)'
      : 'rgba(99, 102, 241, 0.2)';
  }};
  color: ${props => {
    if (!props.active) return '#6b7280';
    return props.variant === 'receive' ? '#34d399' : '#a5b4fc';
  }};

  &:hover:not(:disabled) {
    background: ${props =>
      props.variant === 'receive'
        ? 'rgba(16, 185, 129, 0.15)'
        : 'rgba(99, 102, 241, 0.15)'};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media (max-width: 760px) {
    flex: 1 1 180px;
  }
`;
